<script setup>
import { onBeforeMount } from 'vue';
import { useRouter } from 'vue-router';

import { useStore } from '@/store';

import ListingForm from '@/components/Secondary/Marketplace/ListingForm.vue';
import { resourceV2 } from '@/composables/resource';

const store = useStore();
const router = useRouter();
const seller = resourceV2({
    url: `/api/marketplace/sellers/${store.state.user.id}`
});

onBeforeMount(() => {
    seller.fetch({ swCache: true }).catch(() => {
        if (seller.notFound) {
            router.replace({ name: 'marketplace.sellers.create' });
        }
    });
});
</script>

<template>
    <layout-main>
        <layout-content>
            <content-header>
                <top-nav>
                    <top-nav-back />
                    <top-nav-title>Create Listing</top-nav-title>
                </top-nav>
            </content-header>

            <content-body>
                <div class="px-4 py-6">
                    <template v-if="seller.loadState === 'ready'">
                        <ListingForm />
                    </template>
                    <app-layout-skeleton v-else-if="seller.loadState === 'loading'" />
            </div>
            </content-body>
        </layout-content>
    </layout-main>
</template>
